import MainTemplate from "../MainTemplate";
import TransactionsLeftSide from "./fragments/TransactionsLeftSide";
import TransactionsRightSide from "./fragments/TransactionsRightSide";
import transakcije from "../../../assets/transakcije.svg";

const TransactionsView = () => {
  return (
    <MainTemplate
      title="transactionsPage"
      showBadge
      LeftSideComponent={(props) => <TransactionsLeftSide {...props} />}
      MainComponent={(props) => <TransactionsRightSide {...props} />}
      image={{ src: transakcije, buildSrcFromConnection: false }}
      getUserInfo
    />
  );
};

export default TransactionsView;
